import React from "react";
import { Field } from "formik";

const Checkbox = props => {
  return (
    <Field name={props.name}>
      {({ field, form }) => (
        <div style={{display:'flex', flexDirection:'row'}}>
          <input
            type="checkbox"
            {...props}          
            checked={field.value.includes(props.value)}
            onChange={() => {
              if (field.value.includes(props.value)) {
                
                const nextValue = field.value.filter(
                  value => value !== props.value
                );
                form.setFieldValue(props.name, nextValue);
              } else {
                if(props.name === "sensitiveInfo" && props.value > 90 ){
                    
                  const nextValue = [props.value];
                  form.setFieldValue(props.name, nextValue);
                    
                }else if(props.name === "sensitiveInfo" && props.value < 90){
                    const cleanArray = field.value.filter(
                      value => value < 90
                    );
                    const nextValue = cleanArray.concat(props.value);
                  form.setFieldValue(props.name, nextValue);
                }
                else{
                  const nextValue = field.value.concat(props.value);
                  const finalValue = nextValue.filter((value)=>{return value !== 'allLocations'})
                  form.setFieldValue(props.name, finalValue);
                }
                
              }
            }}
          />
          <label htmlFor={props.value} className='paragraph' style={props.style}>{props.label}</label>
        </div>
      )}
    </Field>
  );
};

export default Checkbox;
